export { getPublicRuntimeConfig, getRuntimeConfigValue } from './libs/getPublicRuntimeConfig';
